import { render, staticRenderFns } from "./adminpush.vue?vue&type=template&id=e8bc995a&"
import script from "./adminpush.vue?vue&type=script&lang=ts&"
export * from "./adminpush.vue?vue&type=script&lang=ts&"
import style0 from "./adminpush.vue?vue&type=style&index=0&id=e8bc995a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports